import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { prefersReducedMotion } from './useLandingEffects'

const FALLBACK_HEADER_H = 72
const GAP = 24 // breathing room between the header and the section heading

const headerHeight = () => {
  const value = getComputedStyle(document.documentElement).getPropertyValue('--header-h')
  return parseInt(value, 10) || FALLBACK_HEADER_H
}

export const scrollToSection = (id) => {
  const behavior = prefersReducedMotion() ? 'auto' : 'smooth'

  if (id === 'home') {
    window.scrollTo({ top: 0, behavior })
    return
  }
  const section = document.getElementById(id)
  if (!section) return

  // A section can mark the element its nav link should land on with
  // data-nav-anchor. Otherwise aim at the content wrapper, which skips the
  // section's 96px of padding so the link lands on content, not blank space.
  const target = section.querySelector('[data-nav-anchor]')
    || section.querySelector(':scope > .wrap')
    || section
  const top = window.scrollY + target.getBoundingClientRect().top - headerHeight() - GAP
  window.scrollTo({ top: Math.max(0, top), behavior })
}

// The site uses HashRouter, so a plain href="#features" would be read as the
// route "/features". Section links scroll with JS instead; from another page
// they navigate home and Landing scrolls once it has mounted.
const useSectionNav = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return useCallback((id) => {
    if (pathname === '/') {
      scrollToSection(id)
    } else {
      navigate('/', { state: { section: id } })
    }
  }, [pathname, navigate])
}

export default useSectionNav
